import { toast } from 'react-toastify';
import ActionResultType from '../interfaces/pieces/ActionResultType';
import type TreeviewActionResult from '../interfaces/pieces/TreeviewActionResult';

/**
 * Applique à l'arbre le résultat d'une action (mise à jour, suppression, ajout, ou modale à ouvrir). Une erreur est
 * affichée ici (toast) : la valeur renvoyée dit si l'action a réussi, pour qu'une modale reste ouverte en cas
 * d'échec.
 */
const handleCheckAction = async <T>(
	actionOrActions: TreeviewActionResult<T> | TreeviewActionResult<T>[],
	onUpdate: (item: T) => T,
	onChange: (rowData: T, shouldRefreshChildren?: boolean) => void,
	onDelete?: (rowData: T) => void,
	onAdd?: (rowData: T) => void,
	setCurrentAction?: (action: TreeviewActionResult<T> | null) => void,
): Promise<boolean> => {
	if (!actionOrActions) return true;

	const actions = Array.isArray(actionOrActions)
		? actionOrActions
		: [actionOrActions];

	try {
		await Promise.all(
			actions.map(async (action) => {
				switch (action.type) {
					case ActionResultType.UPDATE: {
						const result = await action.result;
						const updatedItem = onUpdate(result);
						onChange(updatedItem, action?.shouldRefreshChildren);
						return;
					}

					case ActionResultType.DELETE: {
						const result = await action.result;
						onDelete?.(result);
						return;
					}

					case ActionResultType.ADD: {
						const result = await action.result;
						onAdd?.(result);
						return;
					}

					default:
						setCurrentAction?.(action);
				}
			}),
		);
		return true;
	} catch (error) {
		toast.error(error.message);
		return false;
	}
};

export default handleCheckAction;
